import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import { useEffect, useState } from 'react';
import { Locations } from '@features/location/locations';
import { SearchLocation } from '@features/location/search-location';
import { useLocation } from 'react-router-dom';

export const LocationPage = () => {
  const { pathname } = useLocation();
  const set = useNavbar();
  const [query, setQuery] = useState('');

  useEffect(() => {
    if (pathname === '/initial') {
      set.initial();
    } else {
      set.location();
    }
  }, []);

  return (
    <>
      <SearchLocation onSearch={setQuery} />
      <Locations query={query} isDivided />
    </>
  );
};
